import React from 'react';
import { StyledLink } from '../StyledComponents';
import { FormattedMessage } from 'react-intl';
import config from 'appconfig';
import { StyledPipe } from './StyledPipe';

export const ClaimYourSiteLink = ({ externalUuid }: { externalUuid: string }) => (
  <>
    <StyledLink
      href={`${config.adminHubUrl}/claim?uuid=${externalUuid}`}
      data-cy="actions-section-claim-your-site-button"
    >
      <FormattedMessage
        id="mac.licenses.claim-your-cloud-site"
        defaultMessage="Claim your cloud site"
      />
    </StyledLink>
    <StyledPipe />
  </>
);
